/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import Select from "react-select";
import axios from "axios";
import { Apiurl } from "../../../Utils/utils";
import { toast } from "react-toastify";
import { AiOutlineClose } from "react-icons/ai";

const EMPMonthlyReport = () => {
  const [reportProjects, setReportProjects] = useState([]);
  const [reportFilters, setReportFilters] = useState({
    fromDate: "",
    toDate: "",
    projectId: "",
  });
  const [monthlyReportData, setMonthlyReportData] = useState([]);
  const [loadingReport, setLoadingReport] = useState(false);

  // Task modal states
  const [showTaskModal, setShowTaskModal] = useState(false);
  const [taskList, setTaskList] = useState([]);
  const [filteredTaskList, setFilteredTaskList] = useState([]);
  const [taskSearch, setTaskSearch] = useState("");
  const [loadingTasks, setLoadingTasks] = useState(false);
  const [taskModalData, setTaskModalData] = useState({});

  const getToken = () =>
    localStorage.getItem("token") || sessionStorage.getItem("token");

  const formatTime = (hours, minutes) => {
    const h = hours?.split(":")[0] || "00";
    const m = minutes?.split(":")[1] || "00";
    return `${h} h ${m} m`;
  };

  const fetchReportProjects = () => {
    const LoginToken = getToken();
    axios({
      method: "GET",
      headers: {
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Projects/GetProjectsByUserId`,
    })
      .then((response) => {
        let list = [];
        try {
          const raw = response?.data?.Data || response?.data?.data;
          if (typeof raw === "string") {
            const parsed = JSON.parse(raw);
            list = Array.isArray(parsed)
              ? parsed
              : parsed?.data || parsed?.Data || [];
          } else if (Array.isArray(raw)) {
            list = raw;
          } else {
            list = raw?.data || raw?.Data || [];
          }
        } catch (e) {
          list = [];
        }
        setReportProjects(
          list.map((item) => ({
            id: item.ProjectId || item.projectId,
            name: item.ProjectName || item.projectName,
          }))
        );
      })
      .catch(() => setReportProjects([]));
  };

  const fetchMonthlyReport = () => {
    const { fromDate, toDate, projectId } = reportFilters;

    if (!fromDate || !toDate) {
      toast.error("From Date and To Date are required");
      return;
    }

    setMonthlyReportData([]);
    setLoadingReport(true);

    const LoginToken = getToken();

    const payload = {
      data: JSON.stringify({
        FromDate: fromDate,
        ToDate: toDate,
        ProjectId: projectId || "0",
        UserId: "0",
      }),
    };

    axios({
      method: "POST",
      headers: {
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Task/GetMyMonthlyReport`,
      data: payload,
    })
      .then((response) => {
        if (response?.data?.success) {
          const parsedData = JSON.parse(response?.data?.data || "{}");
          const projects =
            parsedData?.Projects ||
            (Array.isArray(parsedData) ? parsedData : []);

          if (!projects.length) {
            setMonthlyReportData([]);
            toast.error("No record found");
            setLoadingReport(false);
            return;
          }

          setMonthlyReportData(projects);
        } else {
          setMonthlyReportData([]);
          toast.error("No record found");
        }
        setLoadingReport(false);
      })
      .catch((error) => {
        setLoadingReport(false);
        if (error?.response?.status === 401) {
          toast.error("Your session has expired");
        } else {
          toast.error("No record found");
        }
      });
  };

  const fetchTasksForEmployee = (rowData) => {
    const { fromDate, toDate } = reportFilters;

    if (!fromDate || !toDate) {
      toast.error("From Date and To Date are required");
      return;
    }

    const projectId = rowData.ProjectId || rowData.projectId;
    const userId = rowData.UserId || rowData.userId;

    if (!projectId || !userId) {
      toast.error("Project or User info missing");
      return;
    }

    setLoadingTasks(true);
    setTaskModalData({
      projectName: rowData.ProjectName,
      employeeName: rowData.UserName,
    });

    const LoginToken = getToken();

    const payload = {
      data: JSON.stringify({
        FromDate: fromDate,
        ToDate: toDate,
        ProjectId: projectId,
        UserId: userId,
      }),
    };

    axios({
      method: "POST",
      headers: {
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Task/GetTasksForAdminByUser`,
      data: payload,
    })
      .then((response) => {
        if (response?.data?.success) {
          const parsedData = JSON.parse(response?.data?.data);
          const tasks = parsedData?.Tasks || [];
          const formattedTasks = tasks.map((item) => ({
            id: item.Id,
            date: item.Date?.split("T")[0],
            task: item.TaskDetail,
            time: formatTime(item.Hours, item.Minutes),
          }));

          setTaskList(formattedTasks);
          setFilteredTaskList(formattedTasks);
          setTaskSearch("");
          setTaskModalData((prev) => ({
            ...prev,
            totalTime: parsedData?.TotalTime || "",
          }));
          setShowTaskModal(true);
        } else {
          toast.error("No tasks found");
        }
        setLoadingTasks(false);
      })
      .catch(() => {
        setLoadingTasks(false);
        toast.error("Failed to fetch tasks");
      });
  };

  const calculateTotalTime = () => {
    if (!monthlyReportData.length) return "0 h 0 m";

    let totalMinutes = 0;

    monthlyReportData.forEach((item) => {
      const time = item.TotalTime || "0 h 0 m";
      const hoursMatch = time.match(/(\d+)\s*h/);
      const minutesMatch = time.match(/(\d+)\s*m/);

      const hours = hoursMatch ? parseInt(hoursMatch[1], 10) : 0;
      const minutes = minutesMatch ? parseInt(minutesMatch[1], 10) : 0;

      totalMinutes += hours * 60 + minutes;
    });

    const finalHours = Math.floor(totalMinutes / 60);
    const finalMinutes = totalMinutes % 60;

    return `${finalHours} h ${finalMinutes} m`;
  };

  const handleReset = () => {
    setReportFilters({ fromDate: "", toDate: "", projectId: "" });
    setMonthlyReportData([]);
    fetchReportProjects();
  };

  useEffect(() => {
    fetchReportProjects();
  }, []);

  return (
    <div className="timesheet-card">
      {/* Filters */}
      <div className="timesheet-filters">
        <div className="filter-group">
          <label>From Date</label>
          <input
            type="date"
            className="date-input"
            value={reportFilters.fromDate}
          max={
  reportFilters.toDate
    ? reportFilters.toDate
    : new Date().toISOString().split("T")[0]
}
            onChange={(e) => {
  const value = e.target.value;

  if (
    reportFilters.toDate &&
    new Date(value) > new Date(reportFilters.toDate)
  ) {
    toast.error("From Date cannot be greater than To Date");
    return;
  }

  setReportFilters({
    ...reportFilters,
    fromDate: value,
  });
}}
          />
        </div>

        <div className="filter-group">
          <label>To Date</label>
          <input
            type="date"
            className="date-input"
            value={reportFilters.toDate}
          min={reportFilters.fromDate || ""}
max={new Date().toISOString().split("T")[0]}
           onChange={(e) => {
  const value = e.target.value;

  if (
    reportFilters.fromDate &&
    new Date(value) < new Date(reportFilters.fromDate)
  ) {
    toast.error("To Date cannot be smaller than From Date");
    return;
  }

  setReportFilters({
    ...reportFilters,
    toDate: value,
  });
}}
          />
        </div>

        <div className="filter-group">
          <label>Select Project</label>
          <select
            className="select-dropdown"
            value={reportFilters.projectId}
            onChange={(e) =>
              setReportFilters({ ...reportFilters, projectId: e.target.value })
            }
            style={{
              width: "230px",
              padding: "6px 10px",
              border: "1px solid #ccc",
              borderRadius: "4px",
              fontSize: "14px",
              height: "38px",
              backgroundColor: "#fff",
              appearance: "auto",
            }}
          >
            <option value="">All Projects</option>
            {reportProjects.map((p) => (
              <option key={p.id} value={p.id}>
                {p.name}
              </option>
            ))}
          </select>
        </div>

        <button
          className="search-btn"
          onClick={fetchMonthlyReport}
          disabled={loadingReport}
        >
          {loadingReport ? "Loading..." : "Search"}
        </button>

        <button className="reset-btn" onClick={handleReset}>
          Reset
        </button>
      </div>

      <div className="timesheet-table-wrapper">
        <table>
          <thead>
            <tr>
              <th>#</th>
              <th>Project Name</th>
              <th>Time</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {monthlyReportData.length > 0 ? (
              monthlyReportData.map((item, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{item.ProjectName}</td>
                  <td>{item.TotalTime}</td>
                  <td>
                    <button
                      className="edit-btn"
                      onClick={() => fetchTasksForEmployee(item)}
                      disabled={loadingTasks}
                    >
                      View
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4">No record found</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {monthlyReportData.length > 0 && (
        <div
          style={{
            marginTop: "15px",
            textAlign: "center",
            fontWeight: "600",
            fontSize: "16px",
          }}
        >
          Total Time: {calculateTotalTime()}
        </div>
      )}

      {showTaskModal && (
        <div className="delete-modal-overlay">
          <div
            className="delete-modal"
            style={{ maxWidth: "800px", width: "90%", maxHeight: "85vh", overflowY: "auto" }}
          >
            {/* Modal Header */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "16px",
              }}
            >
         <h3
  style={{
    margin: 0,
    textTransform: "uppercase",
  }}
>
  TASK DETAILS
</h3>
              <button
                onClick={() => setShowTaskModal(false)}
                style={{
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                  fontSize: "18px",
                }}
              >
                <AiOutlineClose />
              </button>
            </div>

          <div
  style={{
    display: "grid",
    gridTemplateColumns: "1fr 1fr 1fr",
    gap: "12px",
    marginBottom: "16px",
    alignItems: "start",
  }}
>
              <div>
              <label
  style={{
    fontWeight: 600,
    display: "block",
    marginBottom: 4,
    textAlign: "left",
  }}
>
  Project Name
</label>
                <input
                  type="text"
                  value={taskModalData?.projectName || ""}
                  readOnly
                  style={{ width: "100%", padding: "6px 10px", borderRadius: 4, border: "1px solid #ccc" }}
                />
              </div>
              <div>
               <label
  style={{
    fontWeight: 600,
    display: "block",
    marginBottom: 4,
    textAlign: "left",
  }}
>
  From Date
</label>
                <input
                  type="text"
                  value={reportFilters.fromDate}
                  readOnly
                  style={{ width: "100%", padding: "6px 10px", borderRadius: 4, border: "1px solid #ccc" }}
                />
              </div>
              <div>
                <label
  style={{
    fontWeight: 600,
    display: "block",
    marginBottom: 4,
    textAlign: "left",
  }}
>
  To Date
</label>
                <input
                  type="text"
                  value={reportFilters.toDate}
                  readOnly
                  style={{ width: "100%", padding: "6px 10px", borderRadius: 4, border: "1px solid #ccc" }}
                />
              </div>
            </div>

            <div style={{ marginBottom: "12px", display: "flex", justifyContent: "flex-end" }}>
              <label style={{ marginRight: 8, alignSelf: "center" }}>Search:</label>
             <input
  type="text"
  placeholder="Search by task..."
  value={taskSearch}
                onChange={(e) => {
                  const value = e.target.value;
                  setTaskSearch(value);
                  setFilteredTaskList(
                    taskList.filter((t) =>
                      t.task.toLowerCase().includes(value.toLowerCase())
                    )
                  );
                }}
                style={{ padding: "6px 10px", borderRadius: 4, border: "1px solid #ccc", width: 200 }}
              />
            </div>

            <div className="timesheet-table-wrapper">
              <table>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Date</th>
                    <th>Task</th>
                    <th>Time</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredTaskList.length > 0 ? (
                    filteredTaskList.map((task, idx) => (
                      <tr key={task.id}>
                        <td>{idx + 1}</td>
                        <td>{task.date}</td>
                        <td>{task.task}</td>
                        <td>{task.time}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="4">No tasks found</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {taskModalData?.totalTime && (
              <div
                style={{
                  marginTop: "15px",
                  textAlign: "center",
                  fontWeight: "600",
                  fontSize: "16px",
                }}
              >
                Total Time: {(() => {
                  const [h, m] = taskModalData.totalTime.split(":");
                  return `${parseInt(h, 10)} h ${parseInt(m, 10)} m`;
                })()}
              </div>
            )}

            <div style={{ textAlign: "right", marginTop: "16px" }}>
              <button
                className="reset-btn"
                onClick={() => setShowTaskModal(false)}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default EMPMonthlyReport;